module.exports = __webpack_public_path__ + "img/AUTO_ACTIVITE_EXT_NON.c62da853.svg";